// extracted by mini-css-extract-plugin
export var text = "_i-0";